var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"title"},[_vm._v("赛日SCM系统")]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.username))]),_vm._v(" | "),_c('span',{staticClass:"out",on:{"click":_vm.outLogin}},[_vm._v("退出")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }